module.exports = __webpack_public_path__ + "images/index/img01.a2f7a18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/pien/img01.jpg
// module id = 96nF
// module chunks = 21